import { useEffect, useState } from "react";
import { CardContent, Grid, Typography } from "@mui/material";
import { Tabs } from "antd";
import { selectCurrentUser } from "features/auth/authSlice";
import EmandiReports from "features/E-Mandi/EmandiReport/emandiReport";
import { Mandi } from "features/E-Mandi/EmandiReport/Mandi";
import { useGetDashboardProfileQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import EmployeesList from "features/userManagement/EmployeesList";
import { Card, CardBody } from "reactstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HclDashNav from "components/HclDashNav";
import { store } from "app/store";
import { API_URL } from "app/config";
import RiskManagementGtPoint from "features/dashboard/RiskManagement/RiskManangementGtPoint";
import FarmerListAdmin from "./FarmerListAdmin";
import HclMapFullAdmin from "./HclMapFullAdmin";
const HclDashAdmin = () => {
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const [apiData, setApiData] = useState([]);
  const navigate = useNavigate();
  const { data: userProfile } = useGetDashboardProfileQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );

  const [geoJson, setGeoJson] = useState([]);
  const [mandiCard, setMandiCard] = useState({ total: "", sum: "" });
  const setGeojsonInParent = (data) => {
    setGeoJson(data);
  };
  useEffect(() => {
    handleApi();
  }, []);
  const handleApi = () => {
    const state = store.getState();
    fetch(`${API_URL}/api/v1/onboarding/farmer-aggrigation`, {
      headers: { authorization: `Bearer ${state.auth.accessToken}` },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data !== undefined) {
          const filteredData = data?.data?.filter(
            (item) => item.current_status === "Procurement Done"
          );
          let object = {
            total: data?.data,
            totalQuantity: filteredData?.reduce((sum, item) => {
              let quantity = Number(item.quantity);

              if (item.unit_of_quantity === "Quintals") {
                quantity = quantity * 100;
              }

              return sum + quantity;
            }, 0),
          };
          setMandiCard(object);
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  useEffect(() => {
    if (userProfile) {
      setApiData(userProfile?.data);
    }
  }, [userProfile]);
  const handleProcure = () => {
    const quantity = mandiCard?.totalQuantity || 0;
    let totalProcure = "";
    console.log("quantity", quantity);
    if (quantity < 1000) {
      totalProcure = `${Math.round(quantity).toLocaleString()} Kg`;
    } else if (quantity >= 1000 && quantity < 10000) {
      totalProcure = `${Math.round(quantity / 100).toLocaleString()} Quintal`;
    } else {
      totalProcure = `${Math.round(quantity / 1000).toLocaleString()} MT`;
    }

    return totalProcure;
  };

  const cards = [
    ...(RoleAcessParams.includes("CBBO")
      ? [
          {
            title: "FPO",
            icon: "https://onboarding.agrani.io/assets/wheat-Cd8AZQ9X.png",
            total: apiData?.total_fpos,
            action: () => navigate("/onboarding/fpo"),
          },
        ]
      : []),
    {
      title: "Farmers",
      icon: "https://onboarding.agrani.io/assets/farmers-CTZXnfqs.png",
      total: apiData?.total_customers,
      action: () => navigate("/onboarding/farmers"),
    },
    {
      title: "Land Holding",
      icon: "https://onboarding.agrani.io/assets/acerage-CbrTaoRH.png",
      total: apiData?.land_holding
        ? `${parseInt(apiData.land_holding)} Acres`
        : "0 Acres",
    },

    {
      title: "Crops",
      icon: "https://onboarding.agrani.io/assets/wheat-Cd8AZQ9X.png",
      total: apiData?.crops_dealing?.length,
      // action: () => activateCard("Crops"),
    },
    {
      title: "Procurement",
      icon: "https://cdn-icons-png.flaticon.com/512/4866/4866817.png",
      total: mandiCard?.total?.length,
      totalProcure: handleProcure(),
    },

    {
      title: "Employees",
      icon: "https://onboarding.agrani.io/assets/staff-BoxwbA8A.png",
      total: apiData?.total_employees,
      action: () => navigate(`/employees/${apiData?.organization_details?.id}`),
    },
  ];

  return (
    <div className="" style={{ background: "#fbfbfb" }}>
      <HclDashNav />

      <div
        className="container-fluid "
        style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
      >
        <Grid container spacing={2} alignItems="center" className="mt-0 mt-md-2 mt-lg-2">
          {cards.map((item, index) => (
            <Grid item xs={6} sm={4} md={4} lg={2.4} key={index}>
              <Card style={{ height: "120px" }}>
                <CardContent sx={{ textAlign: "center", p: 3 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {item.title} &nbsp;
                    <img src={item.icon} style={{ width: "1.8rem" }} />
                  </Typography>

                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <h5 className="text-black">Total</h5>
                    <p
                      className="fs-5 "
                      style={{ fontSize: "40px", color: "#006EB7" }}
                    >
                      {item.total}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <div className="mt-4">
          <Tabs
            items={[
              {
                key: "Farmers",
                label: "Farmers",
                children: (
                  <div className="mt-2">
                    <FarmerListAdmin
                      showMap={false}
                      setGeojsonInParent={setGeojsonInParent}
                      isHCL={true}
                    />
                  </div>
                ),
              },
              {
                key: "Cluster Map",
                label: "Cluster Map",
                children: (
                  <Card className="" style={{ height: "90svh" }}>
                    <CardBody className="p-1 p-lg-3">
                      <HclMapFullAdmin RoleAcessParams={RoleAcessParams} />
                    </CardBody>
                  </Card>
                ),
              },

              {
                key: "E-Mandi",
                label: "E-Mandi",
                children: (
                  <div className="mt-2">
                    <Mandi
                      isHCL={true}
                      // setMandiCardData={setMandiCardData}
                    />
                  </div>
                ),
              },
              {
                key: "Live Mandi Prices",
                label: "Live Mandi Prices",
                children: (
                  <div className="" style={{ marginTop: "-1%" }}>
                    <EmandiReports isHCL={true} />
                  </div>
                ),
              },
              {
                key: "GT Point",
                label: "GT Point",
                children: (
                  <div className="mt-2">
                    <RiskManagementGtPoint isHCL={true} />
                  </div>
                ),
              },
              {
                key: "Employees",
                label: "Employees",
                children: (
                  <div className="mt-2">
                    <EmployeesList />
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default HclDashAdmin;
